import { injectable } from 'inversify';
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';
import { GalleryState } from './gallery-interfaces';

@injectable()
export class GalleryStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<GalleryState> {

  key = { id: 35, name: { ns: 'interaction-suspend-data', name: 'gallery' }, format: 'protobuf' }

  serialize(data: GalleryState): Result<Uint8Array, SerializationApi.SerializerError> {

    const message = new GalleryStateProtoMessage({
      touched: data.touched,
    })

    return ProtobufSerializer.serialize<GalleryStateProtoMessage>(message, GalleryStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<GalleryState, SerializationApi.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<GalleryStateProtoMessage>(content, GalleryStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const message = deserializeResult.value
    const result: GalleryState = {
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('GalleryStateProtoMessage')
class GalleryStateProtoMessage extends Message<GalleryStateProtoMessage> {
  @Field.d(1, 'bool', 'repeated')
  touched: boolean[];
}
